import Services from "../../services";

class PengakuanHutangApi {
  // API SERVER
  get(params) {
    return Services.get("hrdu/approval_penyesuaian_voucher/list", { params });
  }

  getHistory(params) {
    return Services.get("hrdu/approval_penyesuaian_voucher/history/list", {
      params,
    });
  }

  getSingle(params) {
    return Services.get("hrdu/approval_penyesuaian_voucher/detail", { params });
  }

  approve(data) {
    return Services.post("hrdu/approval_penyesuaian_voucher/approve", data);
  }
}

export default new PengakuanHutangApi();
